import { render, staticRenderFns } from "./m-scroll-top.vue?vue&type=template&id=af6ff852&scoped=true&"
import script from "./m-scroll-top.vue?vue&type=script&lang=js&"
export * from "./m-scroll-top.vue?vue&type=script&lang=js&"
import style0 from "./m-scroll-top.vue?vue&type=style&index=0&id=af6ff852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ff852",
  null
  
)

export default component.exports